import { GetAppConfigQuery, PointExpirationStrategy, PointsStrategy } from '@ocx/graphql';

import { PointExpirationConfiguration } from '../app-config.types';

type RemotePointExpiration = GetAppConfigQuery['appConfig']['loyaltyProgram']['pointExpiration'];

export const buildPointExpirationRuntimeConfig = (
  pointExpiration: RemotePointExpiration,
  pointsStrategy: PointsStrategy,
): PointExpirationConfiguration => {
  const isFifo = pointExpiration.strategy === PointExpirationStrategy.FirstInFirstOut;

  return {
    ...pointExpiration,
    isFifo,
    isActivityBased: pointExpiration.strategy === PointExpirationStrategy.ActivityBased,
    isNone: pointExpiration.strategy === PointExpirationStrategy.None,
    enabled: pointsStrategy !== PointsStrategy.NotUsed && isFifo,
  };
};
